
<template>
<!-- 添加模板 设为模板 -->
  <div class="modal-template-add">
    <el-dialog
      title="添加模板"
      :visible.sync="dialogVisible"
      width="40%"
      @close="closeDialog"
      custom-class="dialog_template_add"
      >
      <p style="margin: 0 45px 25px 45px;color: #999">
        将当前答题卡设置为模板后，可一键通过模板新建快速复用当前答题卡类型、试题结构、内容布局等信息，快速生成一张新卡
      </p>
      <el-form :model="formdata" :rules="rules" ref="ruleForm">
        <el-form-item label="答题卡名称: " :label-width="formLabelWidth">
          <span v-html="params.acCardName"></span>
          <!-- <el-input v-model="formdata.acCardName" autocomplete="off" style="width: 300px !important"></el-input> -->
        </el-form-item>
        <el-form-item label="模板名称: " :label-width="formLabelWidth" prop="acCardName">
          <el-input v-model="formdata.acCardName" autocomplete="off" maxlength=50 show-word-limit style="width: 300px !important" placeholder="请填写模板名称"></el-input>
        </el-form-item>
        <el-form-item label="学段: " :label-width="formLabelWidth" prop="Period">
          <el-select v-model="formdata.Period" placeholder="请选择学段">
            <el-option
              v-for="item in kMAndPeriod.Period"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目: " :label-width="formLabelWidth" prop="KmCode">
          <el-select v-model="formdata.KmCode" placeholder="请选择科目">
            <el-option
              v-for="item in kMAndPeriod.KM"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')"  :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
import { mapState, mapMutations } from "vuex";
export default {
  props:{
    value: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
  ...mapState("card", {
    kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
    }),
  },
  data() {
    return {
      formLabelWidth: '160px',
      dialogVisible: false,
      formdata: {
        acCardName: '', // 模板名称
        Period: 0, // 学段
        KmCode: 0, // 科目
      },
      rules: {
        acCardName: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
        Period: [
          { required: true, message: '请选择学段', trigger: 'change' }
        ],
        KmCode: [
          { required: true, message: '请选择科目', trigger: 'change' }
        ],
      },
      btnLoading: false
    }
  },
  methods: {
    handleSubmit(formName) {
       this.$refs[formName].validate(async (valid) => {
         if(valid) {
           this.btnLoading = true;
           const result = await AcCardApi.CardToTemplate({
             ...this.formdata,
             acCardGuid: this.params.acCardGuid || 0
           });
           this.btnLoading = false;
           if(result.status == 200) {
             this.$message({
               message: '操作成功~',
               type: 'success'
             });
           } else {
            //  this.$message({
            //    message: result.message,
            //    type: 'error'
            //  });
           }
           this.dialogVisible = false;
         }
       })
    },
    handleCancel(name) {
      this.dialogVisible = false;
    },
    closeDialog(){
        this.isShow = false;
        this.$emit('input', false);
        this.formdata.acCardName = ''
      },
  },
  watch: {
    value(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
    kMAndPeriod(newVal) {
      this.formdata.Period = newVal.Period[0].value;
      this.formdata.KmCode = newVal.KM[0].value;
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" >
.modal-template-add{
.el-select .el-input{
  width: 300px !important;
}
}
.dialog_template_add{
.el-form-item span{
  padding: 0;
  line-height: 26px !important;
}
.el-input__suffix{
  right: -50px !important;
}
}

</style>